import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const useAppManagerStore = defineStore('appManager', () => {
  const _isOnline = ref(true)
  const isOnline = computed(() => {
    return _isOnline.value
  })

  return {
    _isOnline,
    isOnline
  }
})
